import { colors, Grid, Heading, HStack, LinkBox, StackProps, VStack } from "@biblioteksentralen/react";
import { sortAlphabetical } from "@biblioteksentralen/utils";
import { digitalLibraryServiceCategories, getPath } from "@libry-content/common";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { DigitalLibraryServicePreviewDesktop } from "./DigitalLibraryServicePreviewDesktop";
import { LibraryAppPreview } from "./LibraryAppPreview";
import { ServiceCategoryIcon } from "./ServiceCategoryIcon";
import { CategoryWithDigitalLibraryServices, isLibraryAppCategory } from "./utils";

type ServiceCategoryDesktopProps = StackProps & {
  servicesByCategory: CategoryWithDigitalLibraryServices[];
};

export const DigitalLibraryServiceCategoriesDesktop = ({
  servicesByCategory,
  ...stackProps
}: ServiceCategoryDesktopProps) => {
  const { ts } = useTranslation();

  return (
    <VStack as="ul" listStyleType="none" spacing="3rem" alignItems="flex-start">
      {servicesByCategory.map(([category, services]) => (
        <VStack as="li" key={category} alignItems="flex-start" width="100%" aria-labelledby={category} {...stackProps}>
          <HStack alignItems="center" marginBottom="1rem" spacing="1rem">
            {!isLibraryAppCategory(category) && (
              <ServiceCategoryIcon width="3rem" height="3rem" category={category} background={colors.grey10} />
            )}
            <Heading as="h2" size="md" id={category}>
              {ts(digitalLibraryServiceCategories[category])}
            </Heading>
          </HStack>
          <Grid width="100%" gap="1rem" gridTemplateColumns="1fr 1fr">
            {sortAlphabetical(services, ({ name }) => ts(name) ?? "z").map((digitalLibraryService) => {
              const href = getPath(digitalLibraryService);

              if (!digitalLibraryService || !href) {
                console.error("Tried to render digital service with missing information");
                return null;
              }

              if (isLibraryAppCategory(category)) {
                return (
                  <LinkBox key={`${category}_${digitalLibraryService._type}`} gridColumn="span 2">
                    <LibraryAppPreview digitalLibraryService={digitalLibraryService} />
                  </LinkBox>
                );
              }

              return (
                <DigitalLibraryServicePreviewDesktop
                  key={digitalLibraryService._id}
                  digitalLibraryService={digitalLibraryService}
                  category={category}
                />
              );
            })}
          </Grid>
        </VStack>
      ))}
    </VStack>
  );
};
